import React, { forwardRef } from "react";

import classNames from "classnames";
import { Tooltip as ReactTooltip } from "react-tooltip";

import type { JSX, Ref } from "react";
import type { ITooltip, TooltipRefProps } from "react-tooltip";

export const TOOLTIP_PADDING = 12.5;

interface TooltipProps extends ITooltip {
  isError?: boolean;
}

function Tooltip(props: TooltipProps, ref: Ref<TooltipRefProps>): JSX.Element {
  const { isError, ...rest } = props;

  const tootlipClassNames = classNames(
    "rounded-[0.625rem]! text-center! text-[0.78125rem]! ",
    isError &&
      "bg-card! border-2! border-red-400! text-foreground! p-[0.46875rem]!",
    !isError &&
      "bg-foreground! border-0! text-background! shadow! p-[0.78125rem]!",
  );
  return (
    <ReactTooltip
      {...rest} // eslint-disable-line react/jsx-props-no-spreading
      ref={ref}
      arrowColor={isError ? "#f87171" : "var(--foreground)"}
      className={tootlipClassNames}
      opacity={1}
      style={{
        zIndex: 9999,
        padding: TOOLTIP_PADDING,
      }}
    />
  );
}

export default forwardRef(Tooltip);
